import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Register from './pages/Register';
import { ToastContainer } from 'react-toastify';
import Dashboard from './pages/Dashboard';
import Timeline from "./pages/Timeline";
import DailyChecklist from "./pages/DailyChecklist";
import Photos from "./pages/Photos";
import Planner from "./pages/Planner";
import Recommendations from "./pages/Recommendations";
import Settings from "./pages/Settings";
import CloudSync from "./pages/CloudSync";
import Troubleshooting from "./pages/Troubleshooting";
import AdminLogin from "./admin/pages/AdminLogin";
import AdminDashboard from "./admin/pages/AdminDashboard";
import AdminProtectedRoute from "./admin/components/AdminProtectedRoute";
import Farmers from "./admin/pages/Farmers";
import FarmerDetails from "./admin/pages/FarmerDetails";
import Cycles from "./admin/pages/Cycles";
import AdminPhotos from "./admin/pages/Photos";
import Support from "./pages/Support";
import SupportTickets from "./admin/pages/SupportTickets";
import Checklists from "./admin/pages/Checklists";
import AdminPlanner from "./admin/pages/Planner";
import AdminSettings from "./admin/pages/Settings";
import Weather from "./admin/pages/Weather";
import AdminRecommendations from "./admin/pages/Recommendations";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/timeline" element={<Timeline />} />
<Route path="/checklist" element={<DailyChecklist />} />
<Route path="/photos" element={<Photos />} />
<Route path="/planner" element={<Planner />} />
<Route path="/recommendations" element={<Recommendations />} />
<Route path="/settings" element={<Settings />} />
<Route path="/cloud-sync" element={<CloudSync />} />
<Route path="/troubleshooting" element={<Troubleshooting />} />
<Route
  path="/admin/login"
  element={<AdminLogin />}
/>

<Route
  path="/admin/dashboard"
  element={
    <AdminProtectedRoute>
      <AdminDashboard />
    </AdminProtectedRoute>
  }
/>
<Route
  path="/admin/farmers"
  element={
    <AdminProtectedRoute>
      <Farmers />
    </AdminProtectedRoute>
  }
/>
<Route
  path="/admin/farmer/:id"
  element={
    <AdminProtectedRoute>
      <FarmerDetails />
    </AdminProtectedRoute>
  }
/>
<Route
  path="/admin/cycles"
  element={
    <AdminProtectedRoute>
      <Cycles />
    </AdminProtectedRoute>
  }
/>
<Route
  path="/admin/photos"
  element={
    <AdminProtectedRoute>
      <AdminPhotos />
    </AdminProtectedRoute>
  }
/>
<Route
  path="/support"
  element={
      <Support />
    
  }
/>
<Route
  path="/admin/support"
  element={
    <AdminProtectedRoute>
      <SupportTickets />
    </AdminProtectedRoute>
  }
/>
<Route
  path="/admin/checklists"
  element={
    <AdminProtectedRoute>
      <Checklists />
    </AdminProtectedRoute>
  }
/>

<Route
  path="/admin/planner"
  element={
    <AdminProtectedRoute>
      <AdminPlanner />
    </AdminProtectedRoute>
  }
/>
<Route
  path="/admin/settings"
  element={
    <AdminProtectedRoute>
      <AdminSettings />
    </AdminProtectedRoute>
  }
/>
<Route
  path="/admin/weather"
  element={
    <AdminProtectedRoute>
      <Weather />
    </AdminProtectedRoute>
  }
/>
<Route
  path="/admin/recommendations"
  element={
    <AdminProtectedRoute>
      <AdminRecommendations />
    </AdminProtectedRoute>
  }
/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;